import React, { useState } from "react";
import "../CSS/InviteUs.css";
import { sendToWhatsApp } from "./utils/Whatsapp";
import inviteHero from "../Img/inviteushero.jpg";
import inviteGym from "../Img/inviteusgym.jpg";
import inviteForm from "../Img/inviteusform.jpg";
import inviteSchool from "../Img/inviteusschool.jpg";
import inviteCompany from "../Img/inviteuscompany.jpg";
import inviteSociety from "../Img/inviteussociety.jpg";

const InviteUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    type: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `New Invitation Request from Invite Us page:\n\n*Contact Person:* ${formData.name}\n*Contact Number:* ${formData.phone}\n*Email:* ${formData.email}\n*Type:* ${formData.type}\n*Description:* ${formData.description}`;
    sendToWhatsApp(message);
    setFormData({
      name: "",
      phone: "",
      email: "",
      type: "",
      description: "",
    });
  };

  return (
    <div className="invite-us-page">
      {/* Hero Section */}
      <section
        className="invite-hero-section"
        style={{ backgroundImage: `url(${inviteHero})` }}
      >
        <div className="invite-hero-content">
          <h1 className="invite-hero-title">
            Invites for your cycling events.
          </h1>
        </div>
      </section>

      {/* Invitation Form Section */}
      <section className="invite-form-section">
        <div className="invite-form-wrapper">
          {/* Left - Image Collage */}
          <div className="invite-form-image">
            <div className="invite-form-image-grid">
              <img src={inviteGym} alt="Gym event" />
              <img src={inviteSchool} alt="School event" />
              <img src={inviteCompany} alt="Corporate event" />
              <img src={inviteForm} alt="Society event" />
              <img
                src={inviteSociety}
                alt="Community event"
                className="invite-img-wide"
              />
            </div>
          </div>

          {/* Right - Form */}
          <div className="invite-form-content">
            <h2 className="invite-form-title">Send Us An Invitation</h2>
            <p className="invite-form-subtitle">
              We'd truly love to be part of your event and bring the joy of
              cycling along. Share a few details below and our team will get
              back to you with a smile, ready to plan something special together.
            </p>

            <form className="invite-form" onSubmit={handleSubmit}>
              <div className="invite-form-group">
                <label htmlFor="name">Contact Person Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter contact person name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="invite-form-group">
                <label htmlFor="phone">Contact Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Enter contact number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="invite-form-group">
                <label htmlFor="email">Email Id</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter email id"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="invite-form-group">
                <label htmlFor="type">Type</label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select type</option>
                  <option value="Company">Company</option>
                  <option value="Gym">Gym</option>
                  <option value="Society">Society</option>
                  <option value="Community">Community</option>
                  <option value="School">School</option>
                  <option value="Others">Others</option>
                </select>
              </div>

              <div className="invite-form-group">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  rows="4"
                  placeholder="Tell us a bit about your event..."
                  value={formData.description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="invite-submit-btn">
                Send Invitation
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default InviteUs;
